import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AppProvider } from "./context/AppContext";
import { AuthProvider } from "./context/AuthContext";
import { Layout } from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import Study from "./pages/Study";
import Flashcards from "./pages/Flashcards";
import Quiz from "./pages/Quiz";
import Exam from "./pages/Exam";
import Formation from "./pages/Formation";
import Glossaire from "./pages/Glossaire";
import QCodes from "./pages/QCodes";
import Reviser from "./pages/Reviser";
import Favoris from "./pages/Favoris";
import Reglages from "./pages/Reglages";
import AuthCallback from "./pages/AuthCallback";
import { useApp } from "./context/AppContext";
import "./App.css";

function AppToaster() {
  const { theme } = useApp();
  return <Toaster position="bottom-center" theme={theme} richColors />;
}

function AppInner() {
  const location = useLocation();
  // Détecte le retour OAuth (session_id dans le fragment) AVANT tout le reste.
  if (location.hash && location.hash.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <Layout>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/formation" element={<Formation />} />
          <Route path="/formation/:code" element={<Formation />} />
          <Route path="/formation/:code/:sub" element={<Formation />} />
          <Route path="/etudier" element={<Study />} />
          <Route path="/etudier/:code" element={<Study />} />
          <Route path="/cartes" element={<Flashcards />} />
          <Route path="/quiz" element={<Quiz />} />
          <Route path="/examen" element={<Exam />} />
          <Route path="/glossaire" element={<Glossaire />} />
          <Route path="/qcodes" element={<QCodes />} />
          <Route path="/reviser" element={<Reviser />} />
          <Route path="/favoris" element={<Favoris />} />
          <Route path="/reglages" element={<Reglages />} />
        </Routes>
      </Layout>
      <AppToaster />
    </>
  );
}

function App() {
  return (
    <AppProvider>
      <AuthProvider>
        <BrowserRouter>
          <AppInner />
        </BrowserRouter>
      </AuthProvider>
    </AppProvider>
  );
}

export default App;
